export const blockIconsPrivacyandsecuritySyncLockNew = (
	<span className='material-symbols-outlined'>sync_lock</span>
);
